// @ts-nocheck
import { ISDMContextsProps } from '@ldp/sdm-contexts';
import { useMemo, useState } from 'react';
import { customerData, isPharmaprixBanner } from '../utils';
import { SdmProvince, PhxProvince } from '@/data/constants';
export type CartEntries = ISDMContextsProps['sdmCartProviderProps']['entries'];
/**
 * Hook to retrieve the SDM contexts props.
 */
let selectedProduct = {};
export const useSDMContextProps = () => {
  const [entries, setEntries] = useState<CartEntries>({});
  const [isUpdateAction, setIsUpdateAction] = useState(false);
  const [isInitialCartCountUpdated, setIsInitialCartCountUpdated] = useState(false);
  const [pageId, setPageId] = useState('');
  const [pcOptimumAccount, setPcOptimumAccount] = useState(null);
  const defaultProvince = isPharmaprixBanner() ? PhxProvince.QC : SdmProvince.ON;
  const [provinceId, setProvinceId] = useState(defaultProvince);

  return useMemo<ISDMContextsProps>(
    () => ({
      sdmCartProviderProps: {
        /** Mocked cart ID */
        id: customerData.cartId || '',
        /** Mocked cart entries */
        entries,
        /** Mocked add to cart */
        addToCart: (items: any) => {
          setIsUpdateAction(false);
          setEntries((prevEntries: any) => {
            const newEntries = { ...prevEntries };
            const { productName, productCode, quantity, pricingUnits, fulfillmentMethod } = items;
            /** If the entry already exists, and quantity is greater than 0, update the quantity */
            if (quantity > 0) {
              newEntries[productCode] = {
                productName,
                productCode,
                quantity,
                pricingUnits,
                fulfillmentMethod,
              };
            } else {
              /** If the entry already exists, and quantity is 0, remove it */
              delete newEntries[productCode];
            }
            if (typeof prevEntries[items.productCode] !== 'undefined') {
              if (prevEntries[items.productCode].quantity > 0) {
                setIsUpdateAction(true);
              }
            }
            selectedProduct = items;
            return newEntries;
          });
        },
        /** Mocked remove from cart */
        removeFromCart: (items) => {
          setEntries((prevEntries) => {
            /** If the entry already exists, remove it */
            const newEntries = { ...prevEntries };
            Object.keys(items).forEach((key) => {
              delete newEntries[key];
              setIsUpdateAction(false);
            });
            selectedProduct = items;
            return newEntries;
          });
        },
        offerType: 'OG',
        storeId: '1028',
        pickupType: 'STORE',
        isLoading: false,
        selectedProduct,
        isUpdateAction,
        populateEnteries: (cart: any) => {
          setEntries(cart);
        },
        isInitialCartCountUpdated,
        setIsInitialCartCountUpdated,
        pageId,
        setPageId,
      },
      sdmCustomerProviderProps: {
        ...customerData,
        setPcOptimumAccount,
        pcOptimumAccount,
        provinceId,
        setProvinceId,
      },
    }),
    [entries, setEntries, isUpdateAction, isInitialCartCountUpdated, pageId, pcOptimumAccount, provinceId]
  );
};

export default useSDMContextProps;
